import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight, BookOpen } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen w-full bg-[#0f0a2e] overflow-hidden flex items-center py-20 lg:py-0" data-id="element-204">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-[#1e1254] via-[#0f0a2e] to-[#0f0a2e] opacity-80" data-id="element-205" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-206">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-207">
          {/* Left Column: Text */}
          <motion.div className="lg:col-span-7 flex flex-col space-y-8" initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-208">
            <div className="inline-block" data-id="element-209">
              <span className="text-[#d4af37] text-sm font-bold tracking-[0.2em] uppercase border-b border-[#d4af37] pb-1" data-id="element-210">
                Formación Profesional Completa
              </span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight text-white" data-id="element-211">
              Conviértete en un{' '}
              <span className="text-[#d4af37] italic" data-id="element-212">
                Practicante de Reiki Profesional
              </span>{' '}
              con una Formación Estructurada de 3 Niveles
            </h1>

            <p className="text-lg sm:text-xl text-purple-200 max-w-2xl leading-relaxed font-light" data-id="element-213">
              El único sistema progresivo que te lleva desde los fundamentos
              energéticos hasta el dominio avanzado — con herramientas reales
              para ejercer con confianza.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 pt-4" data-id="element-214">
              <a href="#pricing" className="px-8 py-4 bg-[#d4af37] hover:bg-[#f0c040] text-[#0f0a2e] font-bold rounded-sm transition-all duration-300 transform hover:scale-105 flex items-center justify-center gap-2 text-lg shadow-[0_0_20px_rgba(212,175,55,0.3)]" data-id="element-215">
                QUIERO EL SISTEMA COMPLETO <ArrowRight className="w-5 h-5" data-id="element-216" />
              </a>
              <a href="#pricing" className="px-8 py-4 border border-purple-400 text-purple-100 hover:bg-purple-900/30 font-medium rounded-sm transition-all duration-300 flex items-center justify-center gap-2 text-lg" data-id="element-217">
                Ver los Combos
              </a>
            </div>

            <div className="flex flex-wrap gap-4 sm:gap-8 pt-4 text-sm sm:text-base text-purple-300" data-id="element-218">
              <div className="flex items-center gap-2" data-id="element-219">
                <div className="bg-green-500/20 p-1 rounded-full" data-id="element-220">
                  <Check className="w-4 h-4 text-green-400" data-id="element-221" />
                </div>
                <span data-id="element-222">Acceso inmediato</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-223">
                <div className="bg-green-500/20 p-1 rounded-full" data-id="element-224">
                  <Check className="w-4 h-4 text-green-400" data-id="element-225" />
                </div>
                <span data-id="element-226">Formato digital</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-227">
                <div className="bg-green-500/20 p-1 rounded-full" data-id="element-228">
                  <Check className="w-4 h-4 text-green-400" data-id="element-229" />
                </div>
                <span data-id="element-230">Sin experiencia previa</span>
              </div>
            </div>
          </motion.div>

          {/* Right Column: Image */}
          <motion.div className="lg:col-span-5 relative flex justify-center" initial={{
          opacity: 0,
          x: 50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} data-id="element-231">
            <div className="relative z-10 w-full max-w-md mx-auto" data-id="element-232">
              <div className="absolute inset-0 bg-violet-600 blur-[80px] opacity-30 rounded-full" data-id="element-233" />
              <img src="https://cdn.magicpatterns.com/uploads/2LpSGmgWzAztZZHhaMT6RV/20260219_2030_Image_Generation_simple_compose_01khw3svy6f3srpey11zp1m4j5.png" alt="Manual Profesional de Reiki Nivel I" className="relative w-full h-auto drop-shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-234" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}